import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ImgRest",
  "use": "icon-ImgRest-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ImgRest\"><path d=\"M518.2 70.1c-243 0-440 197-440 440v2h56v-2c0-212.1 171.9-384 384-384s384 171.9 384 384c0 211.8-171.5 383.5-383.1 384v56c242.6-0.5 439.1-197.3 439.1-440 0-243-197-440-440-440z\" fill=\"#4b5563\" p-id=\"13024\" /><path d=\"M105 618.9l-75-130h150z\" fill=\"#4b5563\" p-id=\"13025\" /><path d=\"M519.1 922.1m-28 0a28 28 0 1 0 56 0 28 28 0 1 0-56 0Z\" fill=\"#4b5563\" p-id=\"13026\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/ImgRest.svg
// module id = rWm2
// module chunks = 55